import { getMimeType } from "./mime.type";

const b64toBlob = (dataURI, fileExt) => {
  var byteString = atob(dataURI.split(",")[1]);
  var ab = new ArrayBuffer(byteString.length);
  var ia = new Uint8Array(ab);

  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: getMimeType(fileExt) });
};

export { b64toBlob };
